import {onBlockLoaded} from "@plaudit/frontend-apis";

function getProductIdFromForm(blockRoot: HTMLElement, form?: HTMLFormElement|null) {
	if (form) {
		const idElement = form.elements.namedItem("variation_id") ?? form.elements.namedItem("product_id") ?? form.elements.namedItem("add-to-cart");
		if (idElement instanceof RadioNodeList) {
			return [...idElement.values()].filter(element => element.checked).map(element => element.value);
		}
		if (idElement instanceof HTMLInputElement) {
			return idElement.value;
		}
		return null;
	}
	return blockRoot.getAttribute("data-product-id");
}

function updateProductShippingEstimateInForm(blockRoot: HTMLElement, shippingEstimates: Record<string, string>, form?: HTMLFormElement|null, valueOverride?: string) {
	const productId = getProductIdFromForm(blockRoot, form);
	const shippingEstimate = valueOverride ?? (productId && !Array.isArray(productId) ? shippingEstimates[productId] || "" : "");
	for (const element of blockRoot.querySelectorAll(".shipping-estimate")) {
		element.innerHTML = shippingEstimate;
	}
}

let firstBlock = true;
onBlockLoaded({
	blockOrClassName: "msa-region-locked-products/product-shipping-estimate",
	onAdd(blockRoot) {
		const shippingEstimates = JSON.parse(blockRoot.dataset['shippingEstimates'] ?? "{}") as Record<string, string>;
		// blockRoot is the root element of the block (aka the element that has the wp-block-msa-region-locked-products-product-shipping-estimate class on it)
		// You can add any logic that needs to run once per block here
		if (firstBlock) {
			document.addEventListener("msa/region-locked-products/region-update", e => {
				if (!(e instanceof CustomEvent && e.detail['onLoad'])) {
					window.location.reload();
				}
			});
			firstBlock = false;
		}
		const form = blockRoot.closest("form") ?? document.querySelector<HTMLFormElement>("form[data-wp-on--submit='actions.addToCart']");
		updateProductShippingEstimateInForm(blockRoot, shippingEstimates, form);
		if (form) {
			form.addEventListener('change', e => {
				if ((e.target instanceof HTMLInputElement || e.target instanceof HTMLSelectElement) && e.target.id.startsWith("wc_product_attribute_") && e.target.value === "") {
					updateProductShippingEstimateInForm(blockRoot, shippingEstimates, form, "");
				} else {
					updateProductShippingEstimateInForm(blockRoot, shippingEstimates, form);
				}
			});
			new MutationObserver(changes => {
				if (!changes.find(change => change.target instanceof HTMLInputElement && (change.target.name === 'product_id' || change.target.name === 'variation_id'))) {
					return;
				}
				updateProductShippingEstimateInForm(blockRoot, shippingEstimates, form);
			}).observe(form, {attributes: true, subtree: true});
		}
	}
	// If you need to add logic that runs once per removal, add onRemove(blockRoot) {} to this object
});
